import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { Footer, Navbar } from "../../components";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../../constants/apiConstants';
import { formatDate, calculateDifference, dateMonthYears } from "./../Utils";

import "../../assets/css/bootstrap.min.css";
import "../../assets/css/fontawesome-all.min.css";
import "../../assets/css/slick.css";
import "../../assets/css/line-awesome.min.css";
import "../../assets/css/main.css";
import "../../assets/css/responsive.css";
import "../../css/Tabss.css"

// Importing assets
import ProfileImage from "../../assets/images/all/Instituteimage.png";
import NotificationIcon from "../../assets/images/icons/notification-bing-svgrepo-com 1.svg";
import octiconImage from "../../assets/images/icons/octicon_upload-16.svg"

import SearchIcon from "../../assets/images/all/search.svg";

import CommanInstitute from '../../components/CommanInstitute';
import TeacherImage from '../../assets/images/icons/teacehr_+.svg'
import downArrowImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 4.svg'
import UpImage from '../../assets/images/icons/down-arrow-5-svgrepo-com (2) 3.svg'


const InstituteCaption = (props) => {

    const navigate = useNavigate();



    /// Stream end
    // console.log("streamDetailsstreamDetails", managers)
    return (
        <div className="bg_dashboard">

            <div className="container">
                <div className="row">

                    <CommanInstitute />


                    <div class="col-sm-9 col-md-12 col-xl-9 px-md-5 ps-xl-5 ">
                    <div className="row mt-5">
                    <div className="col-md-9 ps-0">
                        <div className="search-box dashboard_search">
                            <input type="text"
                                className="common-input common-input--lg dashboard_search_input pill shadow-sm auto-suggestion-input"
                                placeholder="Search"/>
                            <button type="submit" className="btn btn-main spl_burron  border-0"><img
                                    src={SearchIcon} alt="" /></button>
                        </div>
                    </div>
                    <div className="col-md-2 text-xl-center  mt-3">
                        <img src={NotificationIcon} alt="" />
                    </div>
                    <div className="col-md-1">
                        <div className="dashboard_profile ms-auto">
                            <img src={ProfileImage} alt=""/>
                        </div>
                    </div>
                </div>



                      

                <div class="row px-0 py-4">
                


                    <div class="container my-5">
                        <div class="d-flex justify-content-between">
                            <p class="learm-tilte my-3">Assignment Order</p>

                            <div class="toggle-container">
                                <label class="toggle-button">
                                    <input type="checkbox" id="toggleSwitch"/>
                                    <span class="slider"></span>
                                </label>
                            </div>
                        </div>

                        <div class="row mb-5">
                            <div class="col-sm-12">
                                <p class="font-weight">
                                    Simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                                    industry's
                                    standard dummy text ever since the 1500s, when an unknown printer took a galley of
                                    type and scrambled
                                    it to make a type specimen book.
                                </p>
                                <p class="font-weight">
                                    Simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                                    industry's
                                </p>
                            </div>


                        </div>

                        <div class="row">
                            <div class="col-sm-6 mt-4">
                                <p class="profile_text_2 mb-3">Location</p>
                                <div class="position-relative">
                                    <input type="url" class="form-control dash_borad_input dashboard_input_cust"
                                        id="facebookUrl" placeholder="Facebook Profile Url"/>
                                </div>
                            </div>

                          
                        </div>
                    </div>
                </div>


                       

                        <div class="row mb-5 mt-3">
                            <div class="col-sm-12 d-flex justify-content-between">
                                <span class="learm-tilte2 font-16" onClick={() => navigate("/CourseCircullam")}><img
                                    src={downArrowImage} alt="" /> Previous</span>
                                <span class="learm-tilte2 font-16" onClick={() => navigate("/InstitutePromotion")}>Next <img
                                    src={UpImage} alt="" /></span>
                            </div>
                        </div>



                    </div>
                </div>

            </div>






            {/* Footer */}
            <Footer />
        </div>
    );
};

export default InstituteCaption;






